import { EventV1InfoForm } from "./EventV1InfoForm";

export default EventV1InfoForm;
